import { activateMediaSpecificAttributes } from "../../apis/activateMediaSpecificAttributes.js";

activateMediaSpecificAttributes();

export { setMediaSpecificParametersList as apply } from "../../apis/setMediaSpecificParametersList.js";
